<template>
  <div>
    <el-checkbox v-model="checkAll" disabled :indeterminate="isIndeterminate" @change="handleCheckAllChange">全选</el-checkbox>
    <div style="margin: 0px 0 0 12px;line-height: 30px;">
      <el-checkbox v-model="dfFunctionChecked.dashboardChecked" style="display: block;" disabled @change="allStatusChange">数据看板</el-checkbox>
      <el-checkbox v-model="dfFunctionChecked.widgetsChecked" disabled @change="allStatusChange">可视化配置</el-checkbox>

      <!-- 数据分析 -->
      <div class="big-module">
        <el-checkbox v-model="viewCheckAll" class="all-check" disabled :indeterminate="viewIsIndeterminate" @change="handleCheckAll($event, 'view')">数据分析</el-checkbox>
        <el-checkbox-group v-model="dfFunctionChecked.viewChecked" :disabled="formType == 'look'" @change="handleCheckedChange('view')">
          <el-checkbox v-for="check in viewAll" :key="check.value" :label="check.value" :disabled="check.value == 'sql'">{{ check.name }}</el-checkbox>
        </el-checkbox-group>
      </div>

      <!-- 用户分析 -->
      <div class="big-module">
        <el-checkbox v-model="userCheckAll" class="all-check" :disabled="formType == 'look'" :indeterminate="userIsIndeterminate" @change="handleCheckAll($event, 'user')">用户分析</el-checkbox>
        <el-checkbox-group v-model="dfFunctionChecked.userChecked" :disabled="formType == 'look'" @change="handleCheckedChange('user')">
          <el-checkbox v-for="check in userAll" :key="check.value" :label="check.value">{{ check.name }}</el-checkbox>
        </el-checkbox-group>
      </div>

      <!-- 数据管理 -->
      <div class="big-module">
        <el-checkbox v-model="dataCheckAll" :disabled="eventTrackVersion == 'v1.0' || formType == 'look'" class="all-check" :indeterminate="dataIsIndeterminate" @change="handleCheckAll($event, 'data')">数据管理</el-checkbox>
        <el-checkbox-group v-model="dfFunctionChecked.dataChecked" :disabled="formType == 'look'" @change="handleCheckedChange('data')">
          <el-checkbox v-for="check in dataAll" :key="check.value" :label="check.value" :disabled="eventTrackVersion == 'v1.0' && check.value == 'journal'">{{ check.name }}</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    dfFunctionChecked: {
      type: Object,
      default: () => ({
        dashboardChecked: false,
        widgetsChecked: false,
        viewChecked: [],
        userChecked: [],
        dataChecked: []
      })
    },

    // 编辑还是查看还是审核
    formType: {
      type: String,
      default: ''
    },

    // 埋点版本
    eventTrackVersion: {
      type: String,
      default: ''
    }

  },
  data() {
    return {
      checkAll: false,
      isIndeterminate: false,

      viewIsIndeterminate: false,
      viewAll: [{ name: 'SQL分析', value: 'sql' }, { name: '事件分析', value: 'event' }, { name: '留存分析', value: 'retention' }, { name: '漏斗分析', value: 'funnel' }, { name: '分布分析', value: 'scatter' }, { name: '间隔分析', value: 'interval' }, { name: '路径分析', value: 'path' }, { name: '属性分析', value: 'user' }],
      viewCheckAll: false,

      userIsIndeterminate: false,
      userAll: [{ name: '用户分群', value: 'group' }, { name: '用户标签', value: 'tag' }],
      userCheckAll: false,

      dataIsIndeterminate: false,
      dataAll: [{ name: '元数据管理', value: 'data' }, { name: '日志查看', value: 'journal' }],
      dataCheckAll: false
    }
  },
  watch: {
    // viewChecked(val) {
    //   console.log(val)
    //   this.$emit('update:originViewChecked', val)
    // }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const typeArr = ['view', 'data', 'user']
      for (let i = 0; i < typeArr.length; i++) {
        this.handleCheckedChange(typeArr[i])
      }
    },

    // 子全选切换
    handleCheckAll(val, type) {
      this[type + 'CheckAll'] = val
      this.dfFunctionChecked[type + 'Checked'] = val ? this[type + 'All'].map(item => item.value) : []
      this[type + 'IsIndeterminate'] = false
      this.allStatusChange()
    },

    // 子单值切换
    handleCheckedChange(type) {
      this[type + 'CheckAll'] = this.dfFunctionChecked[type + 'Checked'].length == this[type + 'All'].length
      this[type + 'IsIndeterminate'] = this.dfFunctionChecked[type + 'Checked'].length > 0 && this.dfFunctionChecked[type + 'Checked'].length < this[type + 'All'].length
      this.allStatusChange()
    },

    // 总全选的状态变换
    allStatusChange() {
      this.checkAll = this.dfFunctionChecked.viewChecked.length == this.viewAll.length && this.dfFunctionChecked.userChecked.length == this.userAll.length && this.dfFunctionChecked.dataChecked.length == this.dataAll.length && this.dfFunctionChecked.dashboardChecked && this.dfFunctionChecked.widgetsChecked
      this.isIndeterminate = (this.dfFunctionChecked.viewChecked.length < this.viewAll.length) || (this.dfFunctionChecked.userChecked.length < this.userAll.length) || (this.dfFunctionChecked.dataChecked.length < this.dataAll.length) || !this.dfFunctionChecked.dashboardChecked || !this.dfFunctionChecked.widgetsChecked
    },

    // 总全选切换
    handleCheckAllChange(val) {
      this.dfFunctionChecked.dashboardChecked = val
      this.dfFunctionChecked.widgetsChecked = val
      this.handleCheckAll(val, 'view')
      this.handleCheckAll(val, 'user')
      this.handleCheckAll(val, 'data')
      this.isIndeterminate = false
    }
  }
}
</script>
<style lang="scss" scoped>
.big-module{
  display: flex;
  .all-check{
    min-width: 120px;
  }
}

</style>
